import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { PaginatedResponse } from '@shared/types';
import type { RouteProduct } from '../types';

export function useRouteProducts(routeId: string | null) {
  return useQuery({
    queryKey: queryKeys.routes.products(routeId ?? ''),
    queryFn: () =>
      apiClient.get<PaginatedResponse<RouteProduct>>(`/routes/${routeId}/products`, {
        page: '1',
        size: '100',
      }),
    enabled: !!routeId,
    select: (data) => data.items,
  });
}
